import { render, staticRenderFns } from "./search-clients.vue?vue&type=template&id=8c303f4c&scoped=true"
import script from "./search-clients.vue?vue&type=script&lang=js"
export * from "./search-clients.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c303f4c",
  null
  
)

export default component.exports